import React from 'react';
import moment from 'moment';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';

import CancelOffer from '../Partials/CancelOffer';
import { Row, Col } from '../../Grid';
import { CancelButton, CanceledButton } from './Common';
import reviewIcon from '../../../svg/review-applicants.svg';
import { AnalyticsService } from '../../../services/AnalyticsService';

interface Props {
  offer: Offer;
  type: string;
  goTo: Function;
}

const Container = styled.div`
  background-color: var(--color-beige);
  font-family: 'BrandonGrotesque-Regular';
  margin-bottom: 2px;
`;

const ReviewText = styled.div`
  font-size: 18px;
  margin-top: 10px;
`;

const SelectedText = styled.div`
  color: var(--color-khaki);
  font-size: 12px;
  margin-bottom: 13px;
`;

const DelibirationText = styled.p`
  color: #b4a361;
  font-family: 'BrandonGrotesque-Bold';
  font-size: 14px;
  font-style: italic;
  font-weight: bold;
  line-height: 65px;
  margin: 0 0 0 40px;
`;

const Icon = styled.img`
  margin-top: 7px;
`;

const Link = styled.div`
  cursor: pointer;
`;

class OfferInstance extends React.Component<Props> {
  getDelibirationText() {
    if (moment(this.props.offer.deliberation_starts).isAfter()) {
      const date = moment(this.props.offer.deliberation_starts).format('MMM D, ha');
      return `Delibiration begins ${date}`;
    } else {
      const date = moment(this.props.offer.deliberation_until).format('MMM D, ha');
      return `Make selections by ${date}`;
    }
  }

  render() {
    const selected = this.props.offer.applicants_selected_count;
    const finalizedApplicants = this.props.offer.attendees.filter(
      (attendee) => attendee.applicant_status_locked_at !== null
    ).length;
    const available = this.props.offer.available_spots - finalizedApplicants;
    let reviewNumber = this.props.offer.applicants_total_count;

    // If we have this available, we're dealing with a reopened offer and need
    // to recalculate reviewNumber
    if (this.props.offer.applicants_unreviewed_count) {
      reviewNumber =
        this.props.offer.applicants_unreviewed_count +
        this.props.offer.applicants_liked_count +
        this.props.offer.applicants_dismissed_count
    }

    return (
      <Container>
        <Row>
          <Col size="0 0 260px">
            <DelibirationText>{this.getDelibirationText()}</DelibirationText>
          </Col>
          <Col size="0 0 50px">
            <Icon src={reviewIcon} alt="Review apply offer" />
          </Col>
          <Col size="1">
            <Link
              onClick={() => this.props.goTo('Apply offer', `/offer/apply/${this.props.offer.id}`)}
            >
              <ReviewText>
                Review <strong>{reviewNumber}</strong> applicants for <strong>{available}</strong>{' '}
                spots
              </ReviewText>
              <SelectedText>
                <strong>{selected}</strong> models selected |{' '}
                <strong>{available - selected + finalizedApplicants}</strong> spots remaining.
              </SelectedText>
            </Link>
          </Col>
          {this.props.offer.state !== 'past' && !this.props.offer.canceled_at ? (
            <Col size="0 0 100px">
              <CancelOffer offer={this.props.offer}>
                <div>
                  <CancelButton right />
                </div>
              </CancelOffer>
            </Col>
          ) : null}
          {(this.props.offer.state === 'canceled' || this.props.offer.canceled_at) && (
            <Col size="0 0 109px">
              <CanceledButton>CANCELED</CanceledButton>
            </Col>
          )}
        </Row>
      </Container>
    );
  }
}

function mapDispatchToProps(dispatch: any) {
  return {
    goTo: (name, url: string) => {
      AnalyticsService.track(name + ' tap', {});
      dispatch(push(url));
    },
  };
}

export default connect(null, mapDispatchToProps)(OfferInstance);
